module.exports = __webpack_public_path__ + "img/save-img-btn.d00b5227.png";